export default __webpack_public_path__ + "static/media/No.0-2.7e5cddc0.jpg";